<script setup>
import { computed } from 'vue'
import TripFinderSegmentedControl from './TripFinderSegmentedControl.vue'

const props = defineProps({
  localLabel: {
    type: String,
    default: 'Local',
  },
  modelValue: {
    type: String,
    required: true,
  },
  variant: {
    type: String,
    default: 'desktop',
    validator: (value) => ['desktop', 'mobile'].includes(value),
  },
})

const emit = defineEmits(['update:modelValue'])

const options = computed(() => {
  if (props.variant === 'mobile') {
    return [
      {
        value: 'local',
        label: props.localLabel,
        buttonClass: 'px-0 py-[14px] -translate-x-[4px]',
        sliderLeftOffset: -2,
        sliderWidthOffset: 2,
      },
      {
        value: 'international',
        label: 'International',
        iconName: 'earth',
        buttonClass: 'px-0 py-[14px] translate-x-[2px]',
        sliderLeftOffset: 2,
        sliderWidthOffset: 2,
      },
    ]
  }

  return [
    { value: 'local', label: props.localLabel },
    { value: 'international', label: 'International', iconName: 'earth' },
  ]
})
</script>

<template>
  <TripFinderSegmentedControl
    aria-label="Travel scope selector"
    :model-value="modelValue"
    :options="options"
    :variant="variant"
    @update:modelValue="emit('update:modelValue', $event)"
  />
</template>
